import { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule';
import { useTheme } from '../../../Context/ThemeContext';
import { useLanguage } from '../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import SettingCountInput from '../../../Component/SettingComponent/SettingCountInput';
import HoldingSettingCountInput from '../../../Component/SettingComponent/HoldingSettingCountInput';
import ReserveOpenCountInput from '../../../Component/SettingComponent/ReserveOpenCountInput';
import MaxReserveQueue from '../../../Component/SettingComponent/MaxReserveQueueInput';
import PointInput from '../../../Component/SettingComponent/PointInput';
import LanguageSelectBox from '../../../Component/SettingComponent/LanguageSelectBox';

function SystemSettingView() {
  const history = useHistory();
  const { isDark, applyIsDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { applyLanguage, t } = useLanguage();

  const [data, setData] = useState([{
    id: -1,
    reservationOpenTime: 0,
    reservationOpenTimeUnit: 'day',
    reservationChangeTime: 0,
    reservationChangeTimeUnit: 'min',
    reserveAvailableTime: 0,
    reserveAvailableTimeUnit: 'min',
    holdingAvailableTime: 0,
    holdingAvailableTimeUnit: 'min',
    minimumHoldingDay: 0,
    minimumHoldingDayUnit: 'day',
    maxReserveQueue: 0,
    isViewReserveList: false,
    isAvailableAttendanceInApp: false,
    isOnlyTodayOpenExercise: false,

    isUseAttendancePoint: false,
    isUseConsecutiveAttendancePoint: false,
    isUseWorkoutCompletePoint: false,
    isUseRejoinPoint: false,

    attendancePoint: 0,
    consecutiveAttendancePoint: 0,
    workoutCompletePoint: 0,
    rejoinPoint: 0,
  }]);

  const [isViewReserveList, setIsViewReserveList] = useState(false);
  const [isViewReserveCount, setIsViewReserveCount] = useState(false);
  const [isOpenTimeline, setIsOpenTimeline] = useState(false);
  const [isAvailableSaturdayHolding, setIsAvailableSaturdayHolding] = useState(true);
  const [isAvailableSundayHolding, setIsAvailableSundayHolding] = useState(true);
  const [isAvailableAttendanceInApp, setIsAvailableAttendanceInApp] = useState(false);
  const [isOnlyTodayOpenExercise, setIsOnlyTodayOpenExercise] = useState(false);
  const [isUseNoShowPenalty, setIsUseNoShowPenalty] = useState(false);

  const [isAutoAttendance, setIsAutoAttendance] = useState(false);

  const [isUseAttendancePoint, setIsUseAttendancePoint] = useState(false);
  const [isUseConsecutiveAttendancePoint, setIsUseConsecutiveAttendancePoint] = useState(false);
  const [isUseRejoinPoint, setIsUseRejoinPoint] = useState(false);
  const [isUseWorkoutCompletePoint, setIsUseWorkoutCompletePoint] = useState(false);

  const [attendancePoint, setAttendancePoint] = useState(0);
  const [consecutiveAttendancePoint, setConsecutiveAttendancePoint] = useState(0);
  const [workoutCompletePoint, setWorkoutCompletePoint] = useState(0);
  const [rejoinPoint, setRejoinPoint] = useState(0);

  const [maxReserveQueue, setMaxReserveQueue] = useState(0);

  const TopLevelRef = useRef();

  const ReservationOpenTimeRef = useRef();
  const ReservationAvailableTimeRef = useRef();
  const ReservationChangeTimeRef = useRef();
  const HoldingAvaliableRef = useRef();
  const MinimumHoldingRef = useRef();
  const MaximumHoldingRef = useRef();

  // 시스템 설정값 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('system/', 'GET');

        if (responseData.status === 200) {
          // 아무런 데이터가 없을경우 //
          if (responseData.data[0] === null) {
            setData([{
              id: -1,
              reservationOpenTime: 0,
              reservationOpenTimeUnit: 'day',
              reservationChangeTime: 0,
              reservationChangeTimeUnit: 'min',
              reserveAvailableTime: 0,
              reserveAvailableTimeUnit: 'min',
              holdingAvailableTime: 0,
              holdingAvailableTimeUnit: 'day',
              minimumHoldingDay: 0,
              minimumHoldingDayUnit: 'day',
              maximumHoldingDay: 0,
              maximumHoldingDayUnit: 'day',
              maxReserveQueue: 0,
              isViewReserveList: false,
              isViewReserveCount: false,
              isOpenTimeline: false,
              isAvailableSaturdayHolding: true,
              isAvailableSundayHolding: true,
              isAvailableAttendanceInApp: false,
              isOnlyTodayOpenExercise: false,
              isUseNoShowPenalty: false,
              isUseAutoAttendance: false,

              isUseAttendancePoint: false,
              isUseConsecutiveAttendancePoint: false,
              isUseWorkoutCompletePoint: false,
              isUseRejoinPoint: false,

              attendancePoint: 0,
              consecutiveAttendancePoint: 0,
              workoutCompletePoint: 0,
              rejoinPoint: 0,
            }])
          }
          // 데이터가 존재하는 경우 //
          else {
            setData(responseData.data);
          }
        }
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }, [history])

  // 불러온 설정값을 입력 컴포넌트와 토글 상태에 반영 //
  useEffect(() => {
    if (data[0].reservationOpenTimeUnit === 'min') ReservationOpenTimeRef.current.setValue(data[0].reservationOpenTime);
    else if (data[0].reservationOpenTimeUnit === 'time') ReservationOpenTimeRef.current.setValue(parseInt(data[0].reservationOpenTime / 60));
    else ReservationOpenTimeRef.current.setValue(parseInt((data[0].reservationOpenTime / 60) / 24));

    if (data[0].reservationChangeTimeUnit === 'min') ReservationChangeTimeRef.current.setValue(data[0].reservationChangeTime);
    else if (data[0].reservationChangeTimeUnit === 'time') ReservationChangeTimeRef.current.setValue(parseInt(data[0].reservationChangeTime / 60));
    else ReservationChangeTimeRef.current.setValue(parseInt((data[0].reservationChangeTime / 60) / 24));

    if (data[0].reserveAvailableTimeUnit === 'min') ReservationAvailableTimeRef.current.setValue(data[0].reserveAvailableTime);
    else if (data[0].reserveAvailableTimeUnit === 'time') ReservationAvailableTimeRef.current.setValue(parseInt(data[0].reserveAvailableTime / 60));
    else ReservationAvailableTimeRef.current.setValue(parseInt((data[0].reserveAvailableTime / 60) / 24));

    HoldingAvaliableRef.current.setValue(data[0].holdingAvailableTime);

    ReservationOpenTimeRef.current.setTime(data[0].reservationOpenStandardTime);
    ReservationChangeTimeRef.current.setUnit(data[0].reservationChangeTimeUnit);
    ReservationAvailableTimeRef.current.setUnit(data[0].reserveAvailableTimeUnit);

    MinimumHoldingRef.current.setValue(data[0].minimumHoldingDay);
    MaximumHoldingRef.current.setValue(data[0].maximumHoldingDay);

    setMaxReserveQueue(data[0].maxReserveQueue)

    setIsOpenTimeline(data[0].isOpenTimeline);
    setIsViewReserveList(data[0].isViewReserveList);
    setIsViewReserveCount(data[0].isViewReserveCount);
    setIsAvailableAttendanceInApp(data[0].isAvailableAttendanceInApp);
    setIsOnlyTodayOpenExercise(data[0].isOnlyTodayOpenExercise);
    setIsAvailableSaturdayHolding(data[0].isAvailableSaturdayHolding);
    setIsAvailableSundayHolding(data[0].isAvailableSundayHolding);

    setIsUseNoShowPenalty(data[0].isUseNoShowPenalty);
    setIsAutoAttendance(data[0].isAutoAttendance);

    setIsUseAttendancePoint(data[0].isUseAttendancePoint);
    setIsUseConsecutiveAttendancePoint(data[0].isUseConsecutiveAttendancePoint);
    setIsUseRejoinPoint(data[0].isUseRejoinPoint);
    setIsUseWorkoutCompletePoint(data[0].isUseWorkoutCompletePoint);

    setAttendancePoint(data[0].attendancePoint);
    setConsecutiveAttendancePoint(data[0].consecutiveAttendancePoint);
    setWorkoutCompletePoint(data[0].workoutCompletePoint);
    setRejoinPoint(data[0].rejoinPoint);

  }, [data])

  // 시스템 설정 부분 저장 (낙관적 업데이트 + 실패 시 rollback 콜백 호출) //
  function patchSetting(partialSettings, rollback) {
    const fetchModule = new FetchModule();
    (
      async () => {
        try {
          const responseData = await fetchModule.postDataVersion2('system/setting', 'POST', { settings: partialSettings });

          // 낙관적 업데이트 채택 — 성공 시 응답 동기화 안 함 (data 변경 useEffect가 모든 state를 덮어쓰는 부작용 회피) //
          if (responseData.status === 200) return;

          if (responseData.status === 401) {
            history.push('/login');
            return;
          }

          if (rollback) rollback();
          alert(t('system.alertSaveFailed'));
        }
        catch (e) {
          if (rollback) rollback();
          alert(t('system.alertSaveFailed'));
        }
      }
    )();
  }

  // Boolean 토글 즉시 저장: 낙관적 업데이트 + 실패 시 롤백 //
  function toggleSetting(currentValue, setter, key) {
    const next = !currentValue;
    setter(next);
    patchSetting({ [key]: next }, () => setter(currentValue));
  }

  // 주말 홀딩 설정 상태에 따른 안내 문구 반환 //
  function getWeekendHoldDescription() {
    if (isAvailableSaturdayHolding && isAvailableSundayHolding) return t('system.weekendHoldDescBoth');
    if (isAvailableSaturdayHolding) return t('system.weekendHoldDescSaturday');
    if (isAvailableSundayHolding) return t('system.weekendHoldDescSunday');

    return t('system.weekendHoldDescNone');
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category1}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categorySystem')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper>
            <ComponentRowWrapper>
              <SelectTitleWrapper>
                <SlideTitleWrapper>
                  <Title>{t('system.languageTitle')}</Title>
                  <Explanation>{t('system.languageDesc')}</Explanation>
                </SlideTitleWrapper>
              </SelectTitleWrapper>
              <SelectComponentWrappper style={{ marginLeft: '30px' }}>
                <LanguageSelectBox onChangeLanguage={(val) => applyLanguage(val)} />
              </SelectComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentRowWrapper>
              <SlideTitleWrapper>
                <Title>{t('system.darkModeTitle')}</Title>
                <Explanation>{t('system.darkModeDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => applyIsDark(isDark ? 'light' : 'dark')}>
                <SlideOutBox isClicked={isDark}>
                  <SlideInBox isClicked={isDark} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isDark ? t('system.active') : t('system.inactive')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>
      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category2}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryClasses')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <SlideTitleWrapper width='280px'>
                <Title>{t('system.bookingOpenTitle')}</Title>
                <Explanation>{t('system.bookingOpenDesc')}</Explanation>
              </SlideTitleWrapper>
              <ReserveOpenCountInput
                ref={ReservationOpenTimeRef}
                onCommit={({ value, unit, time }, rollback) => patchSetting({
                  reservationOpenTime: value,
                  reservationOpenTimeUnit: unit,
                  reservationOpenStandardTime: time
                }, rollback)} />
            </ComponentWrapper>
            <ComponentRowWrapper style={{ marginTop: '13px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.waitlistTitle')}</Title>
                <Explanation>{t('system.waitlistDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper>
                <MaxReserveQueue
                  value={maxReserveQueue}
                  setValue={setMaxReserveQueue}
                  onBlur={(val, rollback) => patchSetting({ maxReserveQueue: val }, rollback)} />
              </SlideComponentWrappper>
            </ComponentRowWrapper>
            <ComponentRowWrapper style={{ marginTop: '35px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.autoAttendanceTitle')}</Title>
                <Explanation>{t('system.autoAttendanceDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => toggleSetting(isAutoAttendance, setIsAutoAttendance, 'isAutoAttendance')}>
                <SlideOutBox isClicked={isAutoAttendance}>
                  <SlideInBox isClicked={isAutoAttendance} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isAutoAttendance ? t('system.auto') : t('system.manual')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <SlideTitleWrapper width='280px'>
                <Title>{t('system.bookingCutoffTitle')}</Title>
                <Explanation>{t('system.bookingCutoffDesc')}</Explanation>
              </SlideTitleWrapper>
              <SettingCountInput
                ref={ReservationAvailableTimeRef}
                text={t('system.beforeTime')}
                onCommit={({ value, unit }, rollback) => patchSetting({
                  reserveAvailableTime: value,
                  reserveAvailableTimeUnit: unit === 'hour' ? 'time' : unit
                }, rollback)} />
            </ComponentWrapper>

            <ComponentRowWrapper style={{ marginTop: '32px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.bookingListTitle')}</Title>
                <Explanation>{t('system.bookingListDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => toggleSetting(isViewReserveList, setIsViewReserveList, 'isViewReserveList')}>
                <SlideOutBox isClicked={isViewReserveList}>
                  <SlideInBox isClicked={isViewReserveList} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isViewReserveList ? t('system.public') : t('system.private')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>

            <ComponentRowWrapper style={{ marginTop: '34px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.noShowTitle')}</Title>
                <Explanation>{t('system.noShowDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => toggleSetting(isUseNoShowPenalty, setIsUseNoShowPenalty, 'isUseNoShowPenalty')}>
                <SlideOutBox isClicked={isUseNoShowPenalty}>
                  <SlideInBox isClicked={isUseNoShowPenalty} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseNoShowPenalty ? t('system.active') : t('system.inactive')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <SlideTitleWrapper width='280px'>
                <Title>{t('system.cancelCutoffTitle')}</Title>
                <Explanation>{t('system.cancelCutoffDesc')}</Explanation>
              </SlideTitleWrapper>
              <SettingCountInput
                ref={ReservationChangeTimeRef}
                text={t('system.beforeTime')}
                onCommit={({ value, unit }, rollback) => patchSetting({
                  reservationChangeTime: value,
                  reservationChangeTimeUnit: unit === 'hour' ? 'time' : unit
                }, rollback)} />
            </ComponentWrapper>

            <ComponentRowWrapper style={{ marginTop: '32px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.bookingCountTitle')}</Title>
                <Explanation>{t('system.bookingCountDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => toggleSetting(isViewReserveCount, setIsViewReserveCount, 'isViewReserveCount')}>
                <SlideOutBox isClicked={isViewReserveCount}>
                  <SlideInBox isClicked={isViewReserveCount} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isViewReserveCount ? t('system.public') : t('system.private')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>

            <ComponentRowWrapper style={{ marginTop: '32px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.appAttendanceTitle')}</Title>
                <Explanation>{t('system.appAttendanceDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => toggleSetting(isAvailableAttendanceInApp, setIsAvailableAttendanceInApp, 'isAvailableAttendanceInApp')}>
                <SlideOutBox isClicked={isAvailableAttendanceInApp}>
                  <SlideInBox isClicked={isAvailableAttendanceInApp} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isAvailableAttendanceInApp ? t('system.on') : t('system.off')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>
      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category3}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryMembership')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <Title>{t('system.holdDeadlineTitle')}</Title>
              <Explanation>{t('system.holdDeadlineDesc')}</Explanation>
              <HoldingSettingCountInput
                ref={HoldingAvaliableRef}
                text={t('system.daysBefore')}
                onBlur={(val, rollback) => patchSetting({ holdingAvailableTime: val }, rollback)} />
            </ComponentWrapper>
            <ComponentRowWrapper style={{ marginTop: '32px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.weekendHoldTitle')}</Title>
                <Explanation>{getWeekendHoldDescription()}</Explanation>
              </SlideTitleWrapper>
              <GenderBoxWrapper>
                <GenderBox isClicked={isAvailableSaturdayHolding} onClick={() => toggleSetting(isAvailableSaturdayHolding, setIsAvailableSaturdayHolding, 'isAvailableSaturdayHolding')}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isAvailableSaturdayHolding ? theme.background : theme.text} cursor='pointer'>{t('system.saturday')}</Text>
                </GenderBox>
                <GenderBox isClicked={isAvailableSundayHolding} onClick={() => toggleSetting(isAvailableSundayHolding, setIsAvailableSundayHolding, 'isAvailableSundayHolding')}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isAvailableSundayHolding ? theme.background : theme.text} cursor='pointer'>{t('system.sunday')}</Text>
                </GenderBox>
              </GenderBoxWrapper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <Title>{t('system.minHoldTitle')}</Title>
              <Explanation>{t('system.minHoldDesc')}</Explanation>
              <HoldingSettingCountInput
                ref={MinimumHoldingRef}
                text={t('system.daysMin')}
                onBlur={(val, rollback) => patchSetting({ minimumHoldingDay: val }, rollback)} />
            </ComponentWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <Title>{t('system.maxHoldTitle')}</Title>
              <Explanation>{t('system.maxHoldDesc')}</Explanation>
              <HoldingSettingCountInput
                ref={MaximumHoldingRef}
                text={t('system.daysMax')}
                onBlur={(val, rollback) => patchSetting({ maximumHoldingDay: val }, rollback)} />
            </ComponentWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>

      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category5}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryPoint')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper style={{ marginTop: '13px' }}>
            <ComponentRowWrapper>
              <ComponentColumnWrapper style={{ gap: '4px', marginRight: '50px' }}>
                <SlideTitleWrapper width='270px'>
                  <Title>{t('system.attendancePointTitle')}</Title>
                  <Explanation>{t('system.attendancePointDesc', { count: attendancePoint })}</Explanation>
                </SlideTitleWrapper>
                <ComponentRowWrapper style={{ justifyContent: 'space-between', width: '290px' }}>
                  <PointInput
                    value={attendancePoint}
                    setValue={setAttendancePoint}
                    onBlur={(val, rollback) => patchSetting({ attendancePoint: val }, rollback)} />
                  <SlideComponentWrappper style={{ width: '113px' }} onClick={() => toggleSetting(isUseAttendancePoint, setIsUseAttendancePoint, 'isUseAttendancePoint')}>
                    <SlideOutBox isClicked={isUseAttendancePoint}>
                      <SlideInBox isClicked={isUseAttendancePoint} />
                    </SlideOutBox>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseAttendancePoint ? t('system.active') : t('system.inactive')}</Text>
                  </SlideComponentWrappper>
                </ComponentRowWrapper>
              </ComponentColumnWrapper>

              <ComponentColumnWrapper style={{ gap: '4px', marginRight: '50px'  }}>
                <SlideTitleWrapper width='270px'>
                  <Title>{t('system.streakPointTitle')}</Title>
                  <Explanation>{t('system.streakPointDesc', { count: consecutiveAttendancePoint })}</Explanation>
                </SlideTitleWrapper>
                <ComponentRowWrapper style={{ justifyContent: 'space-between', width: '290px' }}>
                  <PointInput
                    value={consecutiveAttendancePoint}
                    setValue={setConsecutiveAttendancePoint}
                    onBlur={(val, rollback) => patchSetting({ consecutiveAttendancePoint: val }, rollback)} />
                  <SlideComponentWrappper style={{ width: '113px' }} onClick={() => toggleSetting(isUseConsecutiveAttendancePoint, setIsUseConsecutiveAttendancePoint, 'isUseConsecutiveAttendancePoint')}>
                    <SlideOutBox isClicked={isUseConsecutiveAttendancePoint}>
                      <SlideInBox isClicked={isUseConsecutiveAttendancePoint} />
                    </SlideOutBox>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseConsecutiveAttendancePoint ? t('system.active') : t('system.inactive')}</Text>
                  </SlideComponentWrappper>
                </ComponentRowWrapper>
              </ComponentColumnWrapper>

              <ComponentColumnWrapper style={{ gap: '4px' }}>
                <SlideTitleWrapper width='270px'>
                  <Title>{t('system.workoutPointTitle')}</Title>
                  <Explanation>{t('system.workoutPointDesc', { count: workoutCompletePoint })}</Explanation>
                </SlideTitleWrapper>
                <ComponentRowWrapper style={{ justifyContent: 'space-between', width: '290px' }}>
                  <PointInput
                    value={workoutCompletePoint}
                    setValue={setWorkoutCompletePoint}
                    onBlur={(val, rollback) => patchSetting({ workoutCompletePoint: val }, rollback)} />
                  <SlideComponentWrappper style={{ width: '113px' }} onClick={() => toggleSetting(isUseWorkoutCompletePoint, setIsUseWorkoutCompletePoint, 'isUseWorkoutCompletePoint')}>
                    <SlideOutBox isClicked={isUseWorkoutCompletePoint}>
                      <SlideInBox isClicked={isUseWorkoutCompletePoint} />
                    </SlideOutBox>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseWorkoutCompletePoint ? t('system.active') : t('system.inactive')}</Text>
                  </SlideComponentWrappper>
                </ComponentRowWrapper>
              </ComponentColumnWrapper>

            </ComponentRowWrapper>

            <ComponentRowWrapper style={{ marginTop: '34px' }}>
              <ComponentColumnWrapper style={{ gap: '4px' }}>
                <SlideTitleWrapper width='270px'>
                  <Title>{t('system.rejoinPointTitle')}</Title>
                  <Explanation>{t('system.rejoinPointDesc', { count: rejoinPoint })}</Explanation>
                </SlideTitleWrapper>
                <ComponentRowWrapper style={{ justifyContent: 'space-between', width: '290px' }}>
                  <PointInput
                    value={rejoinPoint}
                    setValue={setRejoinPoint}
                    onBlur={(val, rollback) => patchSetting({ rejoinPoint: val }, rollback)} />
                  <SlideComponentWrappper style={{ width: '113px' }} onClick={() => toggleSetting(isUseRejoinPoint, setIsUseRejoinPoint, 'isUseRejoinPoint')}>
                    <SlideOutBox isClicked={isUseRejoinPoint}>
                      <SlideInBox isClicked={isUseRejoinPoint} />
                    </SlideOutBox>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseRejoinPoint ? t('system.active') : t('system.inactive')}</Text>
                  </SlideComponentWrappper>
                </ComponentRowWrapper>
              </ComponentColumnWrapper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>

      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category1}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryLinko')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper>
            <ComponentRowWrapper style={{ marginTop: '13px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.timelinePermTitle')}</Title>
                <Explanation>{t('system.timelinePermDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => toggleSetting(isOpenTimeline, setIsOpenTimeline, 'isOpenTimeline')}>
                <SlideOutBox isClicked={isOpenTimeline}>
                  <SlideInBox isClicked={isOpenTimeline} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isOpenTimeline ? t('system.on') : t('system.off')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentRowWrapper style={{ marginTop: '13px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.timelineOpenTitle')}</Title>
                <Explanation>{t('system.timelineOpenDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => toggleSetting(isOnlyTodayOpenExercise, setIsOnlyTodayOpenExercise, 'isOnlyTodayOpenExercise')}>
                <SlideOutBox isClicked={isOnlyTodayOpenExercise}>
                  <SlideInBox isClicked={isOnlyTodayOpenExercise} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isOnlyTodayOpenExercise ? t('system.todayOpen') : t('system.alwaysOpen')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>
    </TopLevelWrapper>
  )
}

export default SystemSettingView;

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 1035px;

  margin-top: 20px;
  margin-bottom: 260px;

  gap: 33px;

  transition: all 0.3s ease-in-out;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const Catrgory = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  height: 27px;
  padding: 0px 10px;

  border-radius: 5px 5px 0px 0px;
  background-color: ${props => props.backgroundColor};
`;

const InfoBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 28px;

  width: ${props => props.width}px;
  
  gap: 30px;

  border-radius: 0px 16px 16px 16px;
  box-shadow: 30px 16px 30px rgba(142, 140, 138, 0);
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const ComponentColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
`;

const ComponentRowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 300px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 300px;

  gap: 4px;
`;

const SlideTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width ? props.width : '155px'};
  min-width: 155px;

  gap: 4px;
`;

const SelectTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const SlideComponentWrappper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-left: 13px;
  gap: 8px;

  transition: all 0.3s ease-in-out;
`;

const SelectComponentWrappper = styled.div`
  display: flex;

  justify-content: flex-start;
  align-items: center;
`;

const SlideOutBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 69px;
  height: 30px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SlideInBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-left: ${props => props.isClicked ? '41px' : '2px'};

  width: 26px;
  height: 26px;

  border-radius: 6px;
  background-color: ${props => props.isClicked ? props.theme.white : props.theme.gray};

  transition: all 0.3s ease-in-out;
`;

const GenderBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 5px;
`;

const GenderBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  height: 30px;

  padding: 0 10px 0 10px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
